import React, { Component } from 'react';
import { withRouter } from '../../common/utils/NavigationWrapper';
import InstrumentDetails from './InstrumentDetails';
import { getInstrumentDetails } from './InstrumentDetails.actions';
import { connect } from 'react-redux';
import { getReportsList, getReportsListSuccess } from '../../common/state/reports/Reports.actions';
import { getUserInfo, getUserInfoSuccess } from '../../common/state/user/User.actions';
import Unauthorized from '../../pages/Unauthorized/Unauthorized';
import { matchPath } from 'react-router-dom';
import { hasUserPermission } from '../../common/components/PermissionsCheck/PermissionsCheck';

class InstrumentDetailsContainer extends Component {
  constructor() {
    super();

    this.state = {
      instrument: null,
      selectorLinks: null,
      sectionConfig: null,
      hasPermissionToViewInstrument: true,
    };
  }

  componentDidMount() {
    const { params } = this.props;
    getInstrumentDetails(params.id)
      .then((res) =>
        this.setState({
          instrument: res.body,
        })
      )
      .then(this.props._getReports())
      .catch((err) => {
        if (err.response.error.status === 401) {
          this.setState({
            hasPermissionToViewInstrument: false,
          });
        }
      });
  }

  componentDidUpdate(prevProps) {
    if (this.props.sectionConfig != this.state.sectionConfig) {
      if (!this.props.user) {
        this.props._getUserInfo();
      } else {
        this._constructSelectionList();
      }
    }

    if (
      this.state.instrument != null &&
      this.props.params.id != this.state.instrument.SerialNumber
    ) {
      var newSerialNumber = this.props.params.id;
      getInstrumentDetails(newSerialNumber)
        .then((res) =>
          this.setState({
            instrument: res.body,
          })
        )
        .catch((err) => {
          if (err.response.error.status === 401) {
            this.setState({
              hasPermissionToViewInstrument: false,
            });
          }
        });
    }
  }

  render() {
    let loading = false;
    if (!this.state.instrument || !this.props.sectionConfig || !this.state.selectorLinks) {
      loading = true;
    }

    return this.state.hasPermissionToViewInstrument ? (
      <InstrumentDetails
        {...this.state}
        sectionConfig={this.props.sectionConfig}
        loading={loading}
      />
    ) : (
      <Unauthorized />
    );
  }

  _constructSelectionList = () => {
    let sectionConfigList = this.props.sectionConfig;

    if (sectionConfigList && this.state.instrument) {
      this.setState({ sectionConfig: sectionConfigList });
      let selectorLinks = [];

      for (var section in sectionConfigList) {
        if (sectionConfigList.hasOwnProperty(section)) {
          if (
            sectionConfigList[section].hasOwnProperty('allowedPermissions') &&
            !hasUserPermission(sectionConfigList[section].allowedPermissions)
          ) {
            continue;
          } else {
            selectorLinks.splice(sectionConfigList[section].displayOrder, 0, {
              name: sectionConfigList[section].name,
              path: sectionConfigList[section].path,
            });
          }
        }
      }

      this.setState({ selectorLinks }, () => {
        const match = matchPath(
          {
            path: '/instrument-details/:id/:container',
          },
          this.props.location.pathname
        );
        if (!match) {
          //first time loading of component, needs to redirect
          let serialNumber = this.state.instrument.SerialNumber;
          let selectionFromDropdown = selectorLinks.length > 0 ? selectorLinks[0].path : '';
          this.props.navigate(`/instrument-details/${serialNumber}${selectionFromDropdown}`);
        }
      });
    }
  };
}

const mapStateToProps = (state) => ({
  sectionConfig: state.reports ? state.reports : null,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  _getReports: () => {
    return getReportsList()
      .then((res) => dispatch(getReportsListSuccess(res)))
      .catch((err) => console.log(err));
  },
  _getUserInfo: () => {
    return getUserInfo().then((res) => dispatch(getUserInfoSuccess(res.body)));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InstrumentDetailsContainer));
